import { useEffect, useRef, useState } from "react";
import { SELECTOR_THEMES } from "../config/selectorThemes";
import "./signalLoader.css";

export function signalLoaderPreview(location = window.location) {
  if (!["localhost", "127.0.0.1", "[::1]"].includes(location.hostname)) return "baseline";
  const mode = new URLSearchParams(location.search).get("signalLoader");
  return ["signal", "scan", "frame"].includes(mode) ? "signal" : "baseline";
}

export function signalComparisonEnabled(location = window.location) {
  return ["localhost", "127.0.0.1", "[::1]"].includes(location.hostname) &&
    new URLSearchParams(location.search).get("signalCompare") === "1";
}

export default function MGSignalSkeleton({ kind = "cover", animate = true, platform = "twitch", accent = "primary" }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  const theme = SELECTOR_THEMES[`/${platform.toLowerCase()}`] || SELECTOR_THEMES["/twitch"];
  const primary = platform.toLowerCase() === "tiktok" ? "left" : "right";
  const color = theme[accent === "secondary" ? (primary === "left" ? "right" : "left") : primary];
  useEffect(() => {
    if (!animate) return;
    if (typeof IntersectionObserver === "undefined") {
      setVisible(true);
      return;
    }
    const observer = new IntersectionObserver(([entry]) => setVisible(entry.isIntersecting));
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [animate]);
  return <div ref={ref} aria-hidden="true" className={`mg-signal-loader mg-signal-${kind}${animate && visible ? " is-animated" : ""}`}
    style={{ "--mg-signal-color": color }}>
    <span className="mg-signal-corners" />
    <span className="mg-signal-track"><span className="mg-signal-scanline" /></span>
  </div>;
}
